import type { CheckoutProvider } from "./checkoutProvider";
import type { PaymentPlanOption } from "./types";

export type ReadyCheckout = { url: string; identity: string; createdAt: number };

export const getCheckoutIdentity = (plan: PaymentPlanOption, email: unknown, provider: CheckoutProvider): string => JSON.stringify([
  plan.id,
  typeof email === "string" ? email.trim() : "",
  provider,
  plan.currencyCode ?? "USD",
  plan.amount ?? (parseFloat(plan.totalPrice.replace(/[^0-9.]/g, "")) || 0)
]);

export const getReadyCheckoutUrl = (
  ready: ReadyCheckout | null,
  plan: PaymentPlanOption | undefined,
  email: unknown,
  provider: CheckoutProvider
): string | null => ready && plan && ready.identity === getCheckoutIdentity(plan, email, provider) &&
  Date.now() - ready.createdAt < 30 * 60 * 1000 ? ready.url : null;

/** Optional storage and analytics must never prevent hosted checkout navigation. */
export const handoffCheckout = (
  effects: ReadonlyArray<{ name: string; run: () => void }>,
  navigate: () => void,
  reportFailure: (name: string) => void
): void => {
  for (const effect of effects) {
    try {
      effect.run();
    } catch {
      try { reportFailure(effect.name); } catch { /* Reporting is optional too. */ }
    }
  }
  // Keep navigation outside the best-effort guards: callers can offer the saved URL.
  navigate();
};
